// Danish mobile/landline validation. Mirrors the rules used in the calculator
// (`public/calculator/index.html` validateDanishPhone) so both flows reject the
// same garbage inputs (1111-1111, 1234-5678, all-zeros tail, etc.).

export interface PhoneValidation {
  valid: boolean
  msg: string
}

export function digitsOnly(input: string): string {
  return input.replace(/\D/g, '').slice(0, 8)
}

export function formatDanishPhone(digits: string): string {
  return digits.replace(/(\d{2})(?=\d)/g, '$1 ').trim()
}

export function validateDanishPhone(digits: string): PhoneValidation {
  if (digits.length !== 8) return { valid: false, msg: '' }
  if (/^[01]/.test(digits)) return { valid: false, msg: 'Danske numre starter med 2-9' }
  if (/^(\d)\1{7}$/.test(digits)) return { valid: false, msg: 'Indtast venligst et gyldigt nummer' }

  let asc = true
  for (let i = 1; i < 8; i++) {
    if (+digits[i] !== +digits[i - 1] + 1) { asc = false; break }
  }
  if (asc) return { valid: false, msg: 'Indtast venligst et gyldigt nummer' }

  let desc = true
  for (let i = 1; i < 8; i++) {
    if (+digits[i] !== +digits[i - 1] - 1) { desc = false; break }
  }
  if (desc) return { valid: false, msg: 'Indtast venligst et gyldigt nummer' }

  if (/0{5,}$/.test(digits)) return { valid: false, msg: 'Indtast venligst et gyldigt nummer' }
  if (/^(\d{2})\1{3}$/.test(digits)) return { valid: false, msg: 'Indtast venligst et gyldigt nummer' }
  if (/^(\d{4})\1$/.test(digits)) return { valid: false, msg: 'Indtast venligst et gyldigt nummer' }
  if (new Set(digits).size < 3) return { valid: false, msg: 'Indtast venligst et gyldigt nummer' }
  if (/^(\d)\1(\d)\2(\d)\3(\d)\4$/.test(digits)) return { valid: false, msg: 'Indtast venligst et gyldigt nummer' }

  return { valid: true, msg: '' }
}
